import ufeApi from 'services/api/ufeApi';
import userUtils from 'utils/User';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Logout+API

function logout(xCausedHeader = '') {
    const url = '/gway/v1/dotcom/auth/v2/logout';

    const options = {
        method: 'POST',
        headers: {
            'x-requested-source': 'web',
            'Content-type': 'application/json',
            'x-caused-by': xCausedHeader
        },
        body: JSON.stringify({
            email: userUtils.getProfileEmail()
        })
    };

    return ufeApi.makeRequest(url, options, { skipTokenCheck: true }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default logout;
